import { ACTIVE_BASE_REST } from '@/api/constants'
import ApiCore from '@/api/api-core'

export default class SiteFileManager extends ApiCore {
  constructor(store) {
    const path = ACTIVE_BASE_REST + '/site/doc'
    super(store, path)
  }

  getRoot(filter, showProgress) {
    return this._request({
      action: 'root/report',
      method: 'GET',
      params: filter,
      showProgress
    })
  }

  getFolder(scope, path, showProgress) {
    path = path || '/'
    return this._request({
      action: `${scope}/folder`,
      method: 'GET',
      params: { path },
      showProgress
    })
  }

  createFolder(scope, path, showProgress) {
    return this._request({
      action: `${scope}/folder`,
      method: 'POST',
      params: { path },
      showProgress
    })
  }

  deleteFolder(scope, path, showProgress) {
    return this._request({
      action: `${scope}/folder`,
      method: 'DELETE',
      params: { path },
      showProgress
    })
  }

  renameFolder(scope, path, oldName, newName, showProgress) {
    return this._request({
      action: `${scope}/folder/rename`,
      method: 'PATCH',
      params: { path, oldName, newName },
      showProgress
    })
  }

  copyFolder(scope, source, destination, showProgress) {
    return this._request({
      action: `${scope}/folder/copy`,
      method: 'PATCH',
      params: { source, destination },
      showProgress
    })
  }

  moveFolder(scope, source, destination, showProgress) {
    return this._request({
      action: `${scope}/folder/move`,
      method: 'PATCH',
      params: { source, destination },
      showProgress
    })
  }

  upload(scope, path, files, onUploadProgress, showProgress) {
    const formData = new FormData()

    for (let i = 0; i < files.length; i++) {
      const file = files[i]
      formData.append('files', file, file.name)
    }

    return this._request({
      action: `${scope}/file`,
      method: 'POST',
      params: { path },
      form: formData,
      onUploadProgress,
      showProgress
    })
  }

  deleteFile(scope, path, showProgress) {
    return this._request({
      action: `${scope}/file`,
      method: 'DELETE',
      params: { path },
      showProgress
    })
  }

  renameFile(scope, path, oldName, newName, showProgress) {
    return this._request({
      action: `${scope}/file/rename`,
      method: 'PATCH',
      params: { path, oldName, newName },
      showProgress
    })
  }

  copyFile(scope, source, destination, showProgress) {
    return this._request({
      action: `${scope}/file/copy`,
      method: 'PATCH',
      params: { source, destination },
      showProgress
    })
  }

  moveFile(scope, source, destination, showProgress) {
    return this._request({
      action: `${scope}/file/move`,
      method: 'PATCH',
      params: { source, destination },
      showProgress
    })
  }
}
